import React, { useState, useEffect } from 'react';

import {
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material';

import { useTranslate } from 'src/locales';

import { countryCodes } from './country-codes';

interface PhoneNumberInputProps {
  value: string | null;
  onChange: (value: string) => void;
  label?: React.ReactNode;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
}

const CountryCodeSelector: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  label = 'Country Code',
  required = false,
  error = false,
  disabled = false,
  helperText = ''
}) => {

  const [countryCode, setCountryCode] = useState<string>('');

  const { t } = useTranslate();

  useEffect(() => {
    if (value) {
      setCountryCode(value);
      return;
    }

    setCountryCode('');

  }, [value]);

  // Handle country code change
  const handleCountryCodeChange = (code: string) => {

    if (code === '') {
      setCountryCode('');
      onChange('');
      return;
    }

    setCountryCode(code);
    onChange(code);
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={countryCode}
          defaultValue=""
          disabled={disabled}
          onChange={(event) => handleCountryCodeChange(event.target.value as string)}
          label={label}
          required={required}
          error={error}
          renderValue={(selected) => {
            if (countryCode === '') return <div style={{ textAlign: 'center' }}>--</div>;
            const country = countryCodes.find((item) => item.code === countryCode);
            return country?.code;
          }}
        >
          <MenuItem key={10000} value="">
            <em>--</em>
          </MenuItem>

          {countryCodes.sort((a, b) =>
            a.label.localeCompare(b.label)
          ).map((country, index) => (
            <MenuItem key={index} value={country.code}>
              {country.label}
            </MenuItem>
          ))}
        </Select>

      </FormControl>
    </Box>
  );
};

export default CountryCodeSelector;